import React from "react";
import { Box, Loader, LoadingOverlay } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Body } from "../../../components/Typography";

interface OrderTabContentProps<T> {
  data: T[];
  isLoading: boolean;
  error: unknown;
  emptyMessage: string;
  loadedTestId?: string;
  children: (data: T[]) => React.ReactNode;
}

export function OrderTabContent<T>({
  data,
  isLoading,
  error,
  emptyMessage,
  loadedTestId,
  children,
}: OrderTabContentProps<T>) {
  if (isLoading) {
    return (
      <Box sx={{ position: "relative", minHeight: 200 }}>
        <LoadingOverlay loader={<Loader color="brand" size="xl" />} visible={true} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ padding: tokens.spacing[4] }}>
        <Body>Failed to load data.</Body>
      </Box>
    );
  }

  if (data.length === 0) {
    return (
      <Box data-testid={loadedTestId} sx={{ padding: tokens.spacing[4] }}>
        <Body>{emptyMessage}</Body>
      </Box>
    );
  }

  return (
    <div data-testid={loadedTestId} style={{ display: "contents" }}>
      {children(data)}
    </div>
  );
}
